import React from 'react';

import './shared/styles/crema.less';
import 'react-international-phone/style.css';
import {
  AppProvider,
  AppLayout,
  AppLocaleProvider,
  AppThemeProvider,
  AuthRoutes,
} from './domain';
import {BrowserRouter} from 'react-router-dom';
import AuthProvider from './pages/auth/context';

const App = () => {
  return (
    <AppProvider>
      <AuthProvider>
        <AppThemeProvider>
          <AppLocaleProvider>
            <BrowserRouter>
              <AuthRoutes>
                <AppLayout />
              </AuthRoutes>
            </BrowserRouter>
          </AppLocaleProvider>
        </AppThemeProvider>
      </AuthProvider>
    </AppProvider>
  );
};

export default App;
